export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const DEPARTMENTS = [
  'Engineering',
  'Marketing',
  'Sales',
  'Human Resources',
  'Finance',
  'Operations',
  'Customer Support',
  'Product Management',
  'Design',
  'Data Science'
];

export const EXPERIENCE_LEVELS = [
  { value: 0, label: 'Fresher' },
  { value: 1, label: '1 Year' },
  { value: 2, label: '2 Years' },
  { value: 3, label: '3 Years' },
  { value: 4, label: '4 Years' },
  { value: 5, label: '5 Years' },
  { value: 6, label: '6+ Years' },
  { value: 7, label: '7+ Years' },
  { value: 8, label: '8+ Years' },
  { value: 9, label: '9+ Years' },
  { value: 10, label: '10+ Years' }
];

export const TOKEN_KEY = 'talenthub_token';